import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/ralli-logo.svg" alt="RalliPB" className="footer__logo-img" />
              <span>RalliPB</span>
            </div>
            <p>RalliPB is a pickleball community app for finding courts, checking in, seeing friend activity, scheduling sessions, and managing your player profile. It is not currently available on the Apple App Store or Google Play.</p>
          </div>

          <div className="footer__links">
            <h4>Product</h4>
            <a href="/#features">Features</a>
            <a href="/#how-it-works">How It Works</a>
            <a href="/#community">In the App</a>
            <a href="/#rankings">Skill Profile</a>
          </div>

          <div className="footer__links">
            <h4>Community Tools</h4>
            <a href="/#features">Court Discovery</a>
            <a href="/#community">Friend Activity</a>
            <a href="/#community">Session Scheduling</a>
            <Link to="/support">Support</Link>
          </div>

          <div className="footer__links">
            <h4>Company</h4>
            <Link to="/beta">Beta Waitlist</Link>
            <Link to="/feedback">Feedback</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; 2026 RalliPB. All rights reserved.</p>
          <div className="footer__bottom-links">
            <Link to="/support">Support</Link>
            <a href="mailto:dev@rallipb.com">dev@rallipb.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
